import React from "react";
import styles from "./styles.module.scss";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
// import video from "./assets/send.mp4";
import lottie from "./assets/success.lottie";

type Props = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function Thanks({ setOpen }: Props) {
  React.useEffect(() => {
    const close = setTimeout(() => {
      setOpen(false);
    }, 4000);

    return () => {
      clearTimeout(close);
    };
    // 依存配列が無いと親(BottomSheet)の再レンダーのたびにタイマーが
    // リセットされ、ドラッグ操作等を挟むと4秒後に自動的に閉じなくなる。
    // マウント時に1回だけ実行する。
  }, [setOpen]);

  return (
    <div className={styles.thanks}>
      <p className={styles.lead}>
        送信が完了しました。
        <br />
        ありがとうございました。
      </p>
      <div className={styles.send}>
        {/* <video
          className={styles.video}
          src={video}
          playsInline
          muted
          autoPlay
          // loop
        /> */}
        <DotLottieReact
          className={styles.movie}
          // src="https://lottie.host/24030713-206f-43d7-8298-5c51ca388822/BUkKv1wuzv.lottie"
          src={lottie}
          loop
          autoplay
        />
      </div>
      <div className={styles.outro}>
        THANK
        <br />
        YOU
      </div>
    </div>
  );
}
